module.exports = __webpack_public_path__ + "media/assets/images/logo-venergia-e41d94eba92d1794190543a9b6aa9312.svg";